<div class="stepper">
  @for (step of steps(); track step.key; let i = $index) {
  <button
    type="button"
    class="step"
    [class.completed]="getStepState(i) === StepState.Completed"
    [class.active]="getStepState(i) === StepState.Active"
    [class.pending]="getStepState(i) === StepState.Pending"
    [class.clickable]="isStepClickable(i)"
    [disabled]="!isStepClickable(i)"
    [attr.aria-current]="getStepState(i) === StepState.Active ? 'step' : null"
    (click)="onStepClick(step, i)"
  >
    <div class="step-indicator">
      @if (getStepState(i) === StepState.Completed) {
      <span class="step-check">&#10003;</span>
      } @else {
      <span class="step-number">{{ i + 1 }}</span>
      }
    </div>
    <span class="step-label">{{ step.label }}</span>
  </button>

  @if (!isLastStep(i)) {
  <div class="step-connector" [class.completed]="getStepState(i) === StepState.Completed"></div>
  } }
</div>
